import { connect } from 'react-redux';
import Contact from './Contact';

import {
    setNameChange,
    setLastNameChange,
    setPhoneChange,
    setPositionChange,
    setEmailChange,
} from './actions';
import { updateClientStatus } from '../actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    contacts: state.contactUI.contacts,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    phone: state.contactUI.phone,
    email: state.contactUI.email,
    position: state.contactUI.position,
    setNameChange,
    setLastNameChange,
    setPhoneChange,
    setPositionChange,
    setEmailChange,
    updateClientStatus,
});

const combinedActions = {
    setNameChange,
    setLastNameChange,
    setPhoneChange,
    setPositionChange,
    setEmailChange,
    updateClientStatus,
};

export default connect(mapStateToProps, combinedActions)(Contact);



// WEBPACK FOOTER //
// ./src/containers/AddClient/Contact/index.js